import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

export * from "./system";
export * from "./user";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export default pinia;
